import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OtherService } from '../services/other.service';

@Injectable({
  providedIn: 'root'
})
export class SpecialistAuthGuard implements CanActivate {

  constructor(
    private otherService: OtherService,
    private router: Router,
  ) { }

  canActivate() {
    if (!this.otherService.specialistUser) return true;
    return this.router.createUrlTree(['/specialist-verification']);
  }
}